import { Link } from 'react-router-dom';
import type { Show } from '@/mocks/shows';

interface ShowCardProps {
  show: Show;
}

export default function ShowCard({ show }: ShowCardProps) {
  return (
    <Link
      to={`/article/${show.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative overflow-hidden aspect-video">
        <img
          src={show.image}
          alt={show.title}
          title={`${show.title} - 天天影视综艺节目在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 right-2 bg-black/70 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-md">
          {show.duration}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1.5">
          {show.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {show.description}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-0.5">
              <i className="ri-eye-line"></i> {show.views}
            </span>
            <span className="flex items-center gap-0.5">
              <i className="ri-star-fill text-secondary-500 text-xs"></i> {show.rating}
            </span>
          </div>
          <div className="flex flex-wrap gap-1">
            {show.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded text-[10px]"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}